<template>
  <div>
    <div v-if="verificaAdmin">
      <v-col cols="10" offset="1" class="pa-0">
        <v-row class="justify-center align-center ma-2">
          <h3 class="primary--text">Lista de Orçamentos</h3>
          <div style="width: 120px;" class="ml-4">
            <v-select
              :items="filtros"
              v-model="filtro"
              label="Filtro"
              color="primary"
              @change="selFiltro(filtro)"
            ></v-select>
          </div>
          <div class="ml-4">
            <v-chip color="accent">{{ calcs_select.length }}</v-chip>
          </div>
          <div v-if="this.filtro === 3" class="ml-4">
            <v-btn icon @click="delCalcs(filtro)">
              <v-icon color="red">mdi-delete-outline</v-icon>
            </v-btn>
          </div>
        </v-row>
        <v-row class="justify-center">
          <v-list>
            <v-list-item-group v-model="active" color="primary">
              <v-list-item
                three-line
                v-for="calc in calcs_select"
                :key="calc.id"
                aria-selected="active"
                class="ma-1"
                :style="borderItem(calc)"
              >
                <v-list-item-content @click="view(calc)">
                  <v-list-item-title class="primary--text">
                    {{ calc.data }}{{ " - " }}{{ calc.save }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span class="primary--text mr-3"
                      >{{ calc.clienteEmail }}{{ " - " }}{{ calc.tipo }}</span
                    >
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <span class="accent--text mr-3"
                      >{{ calc.tamanho }}{{ " " }}</span
                    >
                    <span class="accent--text mr-3"
                      >{{ laminas(calc) }}{{ " lâminas" }}</span
                    >
                    <strong>{{ calc.valor }}</strong>
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action class="py-5 px-3 ma-1">
                  <v-btn v-if="calc.save !== 'Salvo'" icon color="red" @click="deletar(calc)">
                    <v-icon color="red">mdi-delete-outline</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-row>
      </v-col>

<!-- DIALOGs -->

      <v-dialog
        v-model="dialog"
        scrollable
        persistent
        :overlay="false"
        max-width="500px"
        transition="dialog-transition"
      >
        <v-card>
          <v-card-title primary-title>
            {{ item.clienteNome }}{{ item.clienteEmail }}
            <v-spacer></v-spacer>
            {{ item.valor }}
          </v-card-title
          >
          <v-card-subtitle>
            {{ item.data }}
            <strong class="ml-3">{{ item.clientePhone }}</strong>
          </v-card-subtitle>
          <v-card-text>
            <v-col cols="12">
              <v-row>
                <strong class="pr-2">{{ "Tipo:" }}</strong
                ><span>{{ item.tipo }}</span>
              </v-row>
              <v-row>
                <strong class="pr-2">{{ "Tamanho:" }}</strong
                ><span>{{ item.tamanho }}</span>
              </v-row>
              <v-row>
                <strong class="pr-2">{{ "Lâminas:" }}</strong
                ><span>{{ laminas(item) }}</span>
              </v-row>
              <v-row v-if="item.tipo !== 'Álbum Slim'">
                <strong class="pr-2">{{ "Capa:" }}</strong
                ><span>{{ item.capa }}</span>
                <strong v-if="item.capa !== 'Capa foto'" class="ml-8 pr-2">{{ "Mostruário:" }}</strong><span>{{ item.mostruario }}</span>
              </v-row>
              <v-row>
                <strong class="pr-2">{{ "Laminação:" }}</strong
                ><span>{{ item.laminacao }}</span>
              </v-row>
              <v-row>
                <strong class="pr-2">{{ "Acessórios:" }}</strong>
              </v-row>
              <v-row class="pl-6" v-for="ac in item.acessorios" :key="ac">
                <span class="pl-6">{{ ac }}</span>
              </v-row>
              <v-row>
                <strong class="pr-2">{{ "Demanda especial:" }}</strong
                ><span>{{ item.obs }}</span>
              </v-row>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="warning" text @click="fechar()">fechar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialog2"
        scrollable
        persistent
        :overlay="false"
        max-width="500px"
        transition="dialog-transition"
      >
        <v-card>
          <v-card-title primary-title>{{ "DELETAR ORÇAMENTO?" }}</v-card-title>
          <v-card-subtitle>
            {{ remover.data }}
            <strong class="ml-3">{{ remover.clienteEmail }}</strong>
          </v-card-subtitle>
          <v-card-text>
            <v-col cols="12">
              <v-row>
                <strong class="pr-2">{{ "Tipo:" }}</strong
                ><span>{{ remover.tipo }}</span>
              </v-row>
              <v-row>
                <strong class="pr-2">{{ "Tamanho:" }}</strong
                ><span>{{ remover.tamanho }}</span>
              </v-row>
              <v-row>
                <strong class="pr-2">{{ "Lâminas:" }}</strong
                ><span>{{ laminas(remover) }}</span>
              </v-row>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-btn color="warning" text @click="fechar()">não </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="remove(remover.id)">sim </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div v-else>
      <v-row style="height: 80vh" class="justify-center align-center">
        <v-progress-circular
          :size="60"
          :width="8"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </div>

<!-- FIM -->

  </div>
</template>

<script>
export default {
  name: "admin-list",
  computed: {
    verificaAdmin() {
      return this.$store.getters.verificaAdmin;
    },
    user() {
      return this.$store.getters.user;
    },
    calcs() {
      const c = this.$store.getters.calcs;
      return c;
    },
  },
  watch: {
    calcs(c) {
      console.log("Total:", c.length)
      this.selFiltro(this.filtro)
    }
  },
  mounted() {
    setTimeout(() => {
        console.log(this.verificaAdmin)
        this.calcs_select = this.calcs
        if (!this.verificaAdmin) {
          this.$router.push("/");
        }
    }, 1000);
  },
  data() {
    return {
      loading: false,
      active: "",
      dialog: false,
      dialog2: false,
      remover: "",
      item: {},
      calcs_select: [],
      filtro: 0,
      filtros: [
        { value: 0, text: "Todos" },
        { value: 1, text: "Novos" },
        { value: 2, text: "Salvos" },
        { value: 3, text: "Calculados" }
      ]
    };
  },
  methods: {
    laminas(calc) {
      const num = Number(calc.laminas) + Number(calc.extras);
      return num;
    },
    view(calc) {
      this.item = calc;
      this.setViewTrue(calc)
      this.dialog = true;
    },
    fechar() {
      this.item = {};
      this.dialog = false;
      this.remover = {};
      this.dialog2 = false;
    },
    deletar(calc) {
      this.remover = calc;
      this.dialog2 = true;
    },
    remove(id) {
      this.$store.dispatch("deleteCalc", id);
      this.$store.dispatch("loadCalcs");
      this.fechar();
    },
    borderItem(b) {
      let res = ""
      if (b.view) {
        res = "border-left: 8px solid #DDD;"
      } else {
        res = "border-left: 8px solid teal;"
      }
      return res
    },
    setViewTrue(calc) {
      this.$store.dispatch("setViewTrue", calc.id)
    },
    selFiltro(f){
      switch (f) {
        case 0: this.calcs_select = this.calcs;
          break;
        case 1: this.calcs_select = this.calcs.filter(item => !item.view);
          break;
        case 2: this.calcs_select = this.calcs.filter(item => item.save === "Salvo");
          break;
        case 3: this.calcs_select = this.calcs.filter(item => item.save === "Só calculado");
          break;
        default: this.calcs_select = this.calcs;
          break;
      }
    },
    delCalcs(f) {
      if (f === 3) {
        this.calcs_select = this.calcs.filter(item => item.save === "Só calculado")
        .forEach(item => this.remove(item.id));
        this.filtro = 0
        this.selFiltro(0)
      }
    }
  },
};
</script>
